import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-layout-image-single",
    templateUrl: "./layout-image-single.component.html",
    styleUrls: ["./layout-image-single.component.scss"],
})
export class LayoutImageSingleComponent implements OnInit {
    @Input() inputData: any;
    constructor() {}

    ngOnInit() {
        console.log(this.inputData, "inputData");
    }
}

let tg = [
    {
        Id: 1,
        ParentId: 0,
        MenuName: "Home",
        DisplayName: "Home",
        DisplayNameBangla: "হোম ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 1,
    },
    {
        Id: 2,
        ParentId: 0,
        MenuName: "About Us ",
        DisplayName: "About Us ",
        DisplayNameBangla: "আমাদের সম্পর্কে",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 2,
    },
    {
        Id: 3,
        ParentId: 0,
        MenuName: "Academic ",
        DisplayName: "Academic ",
        DisplayNameBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 3,
    },
    {
        Id: 4,
        ParentId: 0,
        MenuName: "Admission ",
        DisplayName: "Admission ",
        DisplayNameBangla: "ভর্তি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 4,
    },
    {
        Id: 5,
        ParentId: 0,
        MenuName: "Administration  | Associates",
        DisplayName: "Administration  | Associates",
        DisplayNameBangla: "প্রশাসন | সহযোগী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 5,
    },
    {
        Id: 6,
        ParentId: 0,
        MenuName: "Result",
        DisplayName: "Result",
        DisplayNameBangla: "রেজাল্ট ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 6,
    },
    {
        Id: 7,
        ParentId: 0,
        MenuName: "Club & Scociety / Activites ",
        DisplayName: "Club & Scociety / Activites ",
        DisplayNameBangla: "ক্লাব",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 7,
    },
    {
        Id: 8,
        ParentId: 0,
        MenuName: "Golden Jubilee",
        DisplayName: "Golden Jubilee",
        DisplayNameBangla: "সুবর্ণ জয়ন্তী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 8,
    },
    {
        Id: 9,
        ParentId: 0,
        MenuName: "Gallery ",
        DisplayName: "Gallery ",
        DisplayNameBangla: "গ্যালারি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 9,
    },
    {
        Id: 10,
        ParentId: 0,
        MenuName: "Contact ",
        DisplayName: "Contact ",
        DisplayNameBangla: "যোগাযোগ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 10,
    },
    {
        Id: 11,
        ParentId: 0,
        MenuName: "Login ",
        DisplayName: "Login ",
        DisplayNameBangla: "লগ-ইন",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 11,
    },
    {
        Id: 12,
        ParentId: 2,
        MenuName: "At a Glance",
        DisplayName: "At a Glance",
        DisplayNameBangla: "এক নজরে ",
        MenuUrl: "/at-a-glance",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 12,
    },
    {
        Id: 13,
        ParentId: 2,
        MenuName: "History",
        DisplayName: "History",
        DisplayNameBangla: "ইতিহাস",
        MenuUrl: "/history",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 13,
    },
    {
        Id: 14,
        ParentId: 2,
        MenuName: "News And Events",
        DisplayName: "News And Events",
        DisplayNameBangla: "নিউস এন্ড ইভেন্টস ",
        MenuUrl: "/news-and-events",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 14,
    },
    {
        Id: 15,
        ParentId: 2,
        MenuName: "Why Study ",
        DisplayName: "Why Study ",
        DisplayNameBangla: "হোয়াই স্টাডি ",
        MenuUrl: "/why-study",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 15,
    },
    {
        Id: 16,
        ParentId: 2,
        MenuName: "Vision",
        DisplayName: "Vision",
        DisplayNameBangla: "ভিশন",
        MenuUrl: "/vision",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 16,
    },
    {
        Id: 17,
        ParentId: 2,
        MenuName: "Mission",
        DisplayName: "Mission",
        DisplayNameBangla: "মিশন",
        MenuUrl: "/mission",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 17,
    },
    {
        Id: 18,
        ParentId: 2,
        MenuName: "Achievements",
        DisplayName: "Achievements",
        DisplayNameBangla: "অর্জন  | এচিভমেন্টস ",
        MenuUrl: "/achievements",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 18,
    },
    {
        Id: 19,
        ParentId: 2,
        MenuName: "Oath",
        DisplayName: "Oath",
        DisplayNameBangla: "শপথ",
        MenuUrl: "/oath",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 19,
    },
    {
        Id: 20,
        ParentId: 2,
        MenuName: "Infustructure",
        DisplayName: "Infustructure",
        DisplayNameBangla: "অবকাঠামো",
        MenuUrl: "/infustructure",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 20,
    },
    {
        Id: 21,
        ParentId: 3,
        MenuName: "Academic Rules",
        DisplayName: "Academic Rules",
        DisplayNameBangla: "একাডেমিক নিয়ম",
        MenuUrl: "/academic-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 21,
    },
    {
        Id: 22,
        ParentId: 3,
        MenuName: "School Class Routine",
        DisplayName: "School Class Routine",
        DisplayNameBangla: "ক্লাস রুটিন | স্কুল ক্লাস রুটিন",
        MenuUrl: "/class-routine | /school-class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 22,
    },
    {
        Id: 23,
        ParentId: 3,
        MenuName: "College Class Routine",
        DisplayName: "College Class Routine",
        DisplayNameBangla: "কলেজের ক্লাস রুটিন",
        MenuUrl: "/college-class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 23,
    },
    {
        Id: 24,
        ParentId: 3,
        MenuName: "Lesson Plan",
        DisplayName: "Lesson Plan",
        DisplayNameBangla: "পাঠ পরিকল্পনা",
        MenuUrl: "/lesson-plan",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 24,
    },
    {
        Id: 25,
        ParentId: 3,
        MenuName: "Academic Calendar ",
        DisplayName: "Academic Calendar ",
        DisplayNameBangla: "শিক্ষা বর্ষপঞ্জি ",
        MenuUrl: "/academic-calendar ",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 25,
    },
    {
        Id: 26,
        ParentId: 3,
        MenuName: "Holiday Calendar",
        DisplayName: "Holiday Calendar",
        DisplayNameBangla: "ছুটির ক্যালেন্ডার",
        MenuUrl: "/holiday-calender",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 26,
    },
    {
        Id: 27,
        ParentId: 3,
        MenuName: "Notice",
        DisplayName: "Notice",
        DisplayNameBangla: "নোটিশ ",
        MenuUrl: "/notice",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 27,
    },
    {
        Id: 28,
        ParentId: 3,
        MenuName: "Course And Program",
        DisplayName: "Course And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/course-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 28,
    },
    {
        Id: 29,
        ParentId: 3,
        MenuName: "Syllabus And Booklist",
        DisplayName: "Syllabus And Booklist",
        DisplayNameBangla: "সিলেবাস এবং বুকলিস্ট",
        MenuUrl: "/syllabus-and-booklist",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 29,
    },
    {
        Id: 30,
        ParentId: 3,
        MenuName: "Prospectus",
        DisplayName: "Prospectus",
        DisplayNameBangla: "প্রসপেক্টাস",
        MenuUrl: "/prospectus",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 30,
    },
    {
        Id: 31,
        ParentId: 3,
        MenuName: "Magazine",
        DisplayName: "Magazine",
        DisplayNameBangla: "ম্যাগাজিন",
        MenuUrl: "/magazine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 31,
    },
    {
        Id: 32,
        ParentId: 3,
        MenuName: "Rules and Regulations",
        DisplayName: "Rules and Regulations",
        DisplayNameBangla: "নিয়ম এবং প্রবিধান",
        MenuUrl: "/rules-and-regulations",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 32,
    },
    {
        Id: 33,
        ParentId: 3,
        MenuName: "Uniform | School Uniform Info",
        DisplayName: "Uniform | School Uniform Info",
        DisplayNameBangla: "ইউনিফর্ম | স্কুল ইউনিফর্ম তথ্য",
        MenuUrl: "/uniform | /school-uniform-info",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 33,
    },
    {
        Id: 34,
        ParentId: 3,
        MenuName: "Suggestion | Suggestions To Parents",
        DisplayName: "Suggestion | Suggestions To Parents",
        DisplayNameBangla: "পরামর্শ | অভিভাবকদের পরামর্শ",
        MenuUrl: "/suggestion | /suggestions-to-parents",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 34,
    },
    {
        Id: 35,
        ParentId: 3,
        MenuName: "Other Information ",
        DisplayName: "Other Information ",
        DisplayNameBangla: "অন্যান্য",
        MenuUrl: "/online-information ",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 35,
    },
    {
        Id: 36,
        ParentId: 3,
        MenuName: "Coordinator",
        DisplayName: "Coordinator",
        DisplayNameBangla: "কোঅর্ডিনেটর ",
        MenuUrl: "/coordinator",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 36,
    },
    {
        Id: 37,
        ParentId: 3,
        MenuName: "Our Curriculum",
        DisplayName: "Our Curriculum",
        DisplayNameBangla: "আমাদের পাঠ্যক্রম",
        MenuUrl: "/our-curriculum",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 37,
    },
    {
        Id: 38,
        ParentId: 3,
        MenuName: "Extra-Co-Curricular",
        DisplayName: "Extra-Co-Curricular",
        DisplayNameBangla: "এক্সট্রা-কো-কারিকুলার",
        MenuUrl: "/extra-co-curricular",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 38,
    },
    {
        Id: 39,
        ParentId: 3,
        MenuName: "Class Time Schedule",
        DisplayName: "Class Time Schedule",
        DisplayNameBangla: "ক্লাসের সময়সূচী",
        MenuUrl: "/class-time-schedule",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 39,
    },
    {
        Id: 40,
        ParentId: 3,
        MenuName: "Club Activity",
        DisplayName: "Club Activity",
        DisplayNameBangla: "ক্লাব কার্যকলাপ",
        MenuUrl: "/club-activity",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 40,
    },
    {
        Id: 41,
        ParentId: 4,
        MenuName: "Admission Circular ",
        DisplayName: "Admission Circular ",
        DisplayNameBangla: "ভর্তি বিজ্ঞপ্তি ",
        MenuUrl: "/admission-circular |",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 41,
    },
    {
        Id: 42,
        ParentId: 4,
        MenuName: "Admission Form",
        DisplayName: "Admission Form",
        DisplayNameBangla: "ভর্তি ফরম",
        MenuUrl: "/admission-form",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 42,
    },
    {
        Id: 43,
        ParentId: 4,
        MenuName: "Selected Candidates",
        DisplayName: "Selected Candidates",
        DisplayNameBangla: "নির্বাচিত প্রার্থীরা",
        MenuUrl: "/selected-candidates",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 43,
    },
    {
        Id: 44,
        ParentId: 4,
        MenuName: "Waiting list",
        DisplayName: "Waiting list",
        DisplayNameBangla: "ওয়েটিং লিস্ট ",
        MenuUrl: "/waiting-list",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 44,
    },
    {
        Id: 45,
        ParentId: 4,
        MenuName: "Admission Result",
        DisplayName: "Admission Result",
        DisplayNameBangla: "ভর্তির ফলাফল",
        MenuUrl: "/admission-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 45,
    },
    {
        Id: 46,
        ParentId: 4,
        MenuName: "Exam Rules",
        DisplayName: "Exam Rules",
        DisplayNameBangla: "পরীক্ষার নিয়ম",
        MenuUrl: "/exam-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 46,
    },
    {
        Id: 47,
        ParentId: 4,
        MenuName: "Courses And Program",
        DisplayName: "Courses And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/courses-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 47,
    },
    {
        Id: 48,
        ParentId: 4,
        MenuName: "FAQ",
        DisplayName: "FAQ",
        DisplayNameBangla: "এফ এ কিউ ",
        MenuUrl: "/faq",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 48,
    },
    {
        Id: 49,
        ParentId: 4,
        MenuName: "Admission Procedure",
        DisplayName: "Admission Procedure",
        DisplayNameBangla: "ভর্তির পদ্ধতি",
        MenuUrl: "/admission-procedure",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 49,
    },
    {
        Id: 50,
        ParentId: 4,
        MenuName: "Payment Process",
        DisplayName: "Payment Process",
        DisplayNameBangla: "পেমেন্ট প্রক্রিয়া",
        MenuUrl: "/payment-process",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 50,
    },
    {
        Id: 51,
        ParentId: 4,
        MenuName: "Download Admit Card",
        DisplayName: "Download Admit Card",
        DisplayNameBangla: "অ্যাডমিট কার্ড ডাউনলোড",
        MenuUrl: "/download-admit-card",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 51,
    },
    {
        Id: 52,
        ParentId: 4,
        MenuName: "Admission Instruction",
        DisplayName: "Admission Instruction",
        DisplayNameBangla: "ভর্তির নির্দেশনা",
        MenuUrl: "/admission-instruction",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 52,
    },
    {
        Id: 53,
        ParentId: 5,
        MenuName: "Governing Body",
        DisplayName: "Governing Body",
        DisplayNameBangla: "পরিচালনা পর্ষদ",
        MenuUrl: "/governing-body",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 53,
    },
    {
        Id: 54,
        ParentId: 5,
        MenuName: "Message Of Chief Patron",
        DisplayName: "Message Of Chief Patron",
        DisplayNameBangla: "প্রধান পৃষ্ঠপোষক বার্তা",
        MenuUrl: "/message-of-chief-patron",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 54,
    },
    {
        Id: 55,
        ParentId: 5,
        MenuName: "Message Of Chairman ",
        DisplayName: "Message Of Chairman ",
        DisplayNameBangla: "চেয়ারম্যানের বার্তা",
        MenuUrl: "/message-of-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 55,
    },
    {
        Id: 56,
        ParentId: 5,
        MenuName: "Message of Vice Chairman",
        DisplayName: "Message of Vice Chairman",
        DisplayNameBangla: "ভাইস চেয়ারম্যানের বার্তা",
        MenuUrl: "/message-of-vice-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 56,
    },
    {
        Id: 57,
        ParentId: 5,
        MenuName: "Message of Principal",
        DisplayName: "Message of Principal",
        DisplayNameBangla: "অধ্যক্ষের বার্তা",
        MenuUrl: "/message-of-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 57,
    },
    {
        Id: 58,
        ParentId: 5,
        MenuName: "Message Of Vice Principal",
        DisplayName: "Message Of Vice Principal",
        DisplayNameBangla: "ভাইস প্রিন্সিপালের বার্তা",
        MenuUrl: "/message-of-vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 58,
    },
    {
        Id: 59,
        ParentId: 5,
        MenuName: "Student Advisor",
        DisplayName: "Student Advisor",
        DisplayNameBangla: "ছাত্র-ছাত্রীদের উপদেষ্টা",
        MenuUrl: "/student-advisor",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 59,
    },
    {
        Id: 60,
        ParentId: 5,
        MenuName: "Academic Organogram",
        DisplayName: "Academic Organogram",
        DisplayNameBangla: "একাডেমিক অর্গানোগ্রাম",
        MenuUrl: "/academic-organogram",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 60,
    },
    {
        Id: 61,
        ParentId: 5,
        MenuName: "Ex-Chairman | Chairman",
        DisplayName: "Ex-Chairman | Chairman",
        DisplayNameBangla: "প্রাক্তন চেয়ারম্যান | চেয়ারম্যান",
        MenuUrl: "/ex-chairman | /chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 61,
    },
    {
        Id: 62,
        ParentId: 5,
        MenuName: "Ex-Principals | Principal",
        DisplayName: "Ex-Principals | Principal",
        DisplayNameBangla: "প্রাক্তন অধ্যক্ষ | অধ্যক্ষ",
        MenuUrl: "/ex-principals | /principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 62,
    },
    {
        Id: 63,
        ParentId: 5,
        MenuName: "Ex-Vice Principals | Vice Principal",
        DisplayName: "Ex-Vice Principals | Vice Principal",
        DisplayNameBangla: "প্রাক্তন ভাইস প্রিন্সিপাল | ভাইস প্রিন্সিপাল",
        MenuUrl: "/ex-vice-principals | /vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 63,
    },
    {
        Id: 64,
        ParentId: 5,
        MenuName: "Ex-Teacher",
        DisplayName: "Ex-Teacher",
        DisplayNameBangla: "প্রাক্তন শিক্ষক",
        MenuUrl: "/ex-teacher",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 64,
    },
    {
        Id: 65,
        ParentId: 5,
        MenuName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayNameBangla: "শিক্ষকমন্ডলী (স্কুল শাখা))",
        MenuUrl: "/teacher-information",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 65,
    },
    {
        Id: 66,
        ParentId: 5,
        MenuName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayNameBangla: "শিক্ষকমন্ডলী (কলেজ শাখা)",
        MenuUrl: "/teacher's-list-college | /teacher-information-grils-section",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 66,
    },
    {
        Id: 67,
        ParentId: 5,
        MenuName: "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayName:
            "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayNameBangla: "কর্মচারীর তালিকা",
        MenuUrl: "/staff-information | /officers-&-staffs-list | /non-teaching",
        IsLeaf: true,
        FileType: 6,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 67,
    },
    {
        Id: 68,
        ParentId: 6,
        MenuName: "Institution Result",
        DisplayName: "Institution Result",
        DisplayNameBangla: "প্রতিষ্ঠানের ফলাফল",
        MenuUrl: "/institution-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 68,
    },
    {
        Id: 69,
        ParentId: 6,
        MenuName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayNameBangla: "বোর্ডের ফলাফল | এইচএসসি ফলাফল | এসএসসি ফলাফল",
        MenuUrl: "/board-result | /hsc-results | /ssc-results",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 69,
    },
    {
        Id: 70,
        ParentId: 6,
        MenuName: "Scholarship Result",
        DisplayName: "Scholarship Result",
        DisplayNameBangla: "বৃত্তি ফলাফল",
        MenuUrl: "/scholarship-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 70,
    },
    {
        Id: 71,
        ParentId: 6,
        MenuName: "Admission Test Result",
        DisplayName: "Admission Test Result",
        DisplayNameBangla: "ভর্তি পরীক্ষার ফলাফল",
        MenuUrl: "/admission-test-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 71,
    },
    {
        Id: 72,
        ParentId: 6,
        MenuName: "Recruitment",
        DisplayName: "Recruitment",
        DisplayNameBangla: "নিয়োগ | রিক্রুটমেন্ট",
        MenuUrl: "/recruitment",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 72,
    },
    {
        Id: 73,
        ParentId: 6,
        MenuName: "Recruitment Result",
        DisplayName: "Recruitment Result",
        DisplayNameBangla: "নিয়োগের ফলাফল | রিক্রুটমেন্ট ফলাফল ",
        MenuUrl: "/recruitment-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 73,
    },
    {
        Id: 74,
        ParentId: 7,
        MenuName: "Cultural Club",
        DisplayName: "Cultural Club",
        DisplayNameBangla: "সাংস্কৃতিক ক্লাব",
        MenuUrl: "/cultural-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 74,
    },
    {
        Id: 75,
        ParentId: 7,
        MenuName: "Quiz club",
        DisplayName: "Quiz club",
        DisplayNameBangla: "কুইজ ক্লাব",
        MenuUrl: "/quiz-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 75,
    },
    {
        Id: 76,
        ParentId: 7,
        MenuName: "IT club",
        DisplayName: "IT club",
        DisplayNameBangla: "আইটি ক্লাব",
        MenuUrl: "/it-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 76,
    },
    {
        Id: 77,
        ParentId: 7,
        MenuName: "Business club",
        DisplayName: "Business club",
        DisplayNameBangla: "ব্যবসায়িক ক্লাব",
        MenuUrl: "/business-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 77,
    },
    {
        Id: 78,
        ParentId: 7,
        MenuName: "Blood Donation club",
        DisplayName: "Blood Donation club",
        DisplayNameBangla: "রক্তদান ক্লাব",
        MenuUrl: "/blood-donation-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 78,
    },
    {
        Id: 79,
        ParentId: 7,
        MenuName: "Quran Learning Club",
        DisplayName: "Quran Learning Club",
        DisplayNameBangla: "কোরআন লার্নিং ক্লাব",
        MenuUrl: "/quran-learning-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 79,
    },
    {
        Id: 80,
        ParentId: 7,
        MenuName: "General Knowledge Club",
        DisplayName: "General Knowledge Club",
        DisplayNameBangla: "সাধারণ জ্ঞান ক্লাব",
        MenuUrl: "/general-knowledge-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 80,
    },
    {
        Id: 81,
        ParentId: 7,
        MenuName: "Language Club",
        DisplayName: "Language Club",
        DisplayNameBangla: "ভাষা ক্লাব",
        MenuUrl: "/language-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 81,
    },
    {
        Id: 82,
        ParentId: 7,
        MenuName: "Sports & Karate Club",
        DisplayName: "Sports & Karate Club",
        DisplayNameBangla: "ক্রীড়া ও কারাতে ক্লাব",
        MenuUrl: "/sports-&-karate-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 82,
    },
    {
        Id: 83,
        ParentId: 7,
        MenuName: "Science Club:",
        DisplayName: "Science Club:",
        DisplayNameBangla: "বিজ্ঞান ক্লাব:",
        MenuUrl: "",
        IsLeaf: false,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 83,
    },
    {
        Id: 84,
        ParentId: 7,
        MenuName: "Physics",
        DisplayName: "Physics",
        DisplayNameBangla: "পদার্থ-বিজ্ঞান",
        MenuUrl: "/physics",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 84,
    },
    {
        Id: 85,
        ParentId: 7,
        MenuName: "Chemistry",
        DisplayName: "Chemistry",
        DisplayNameBangla: "রসায়ন",
        MenuUrl: "/chemistry",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 85,
    },
    {
        Id: 86,
        ParentId: 7,
        MenuName: "BNCC Society",
        DisplayName: "BNCC Society",
        DisplayNameBangla: "বিএনসিসি সোসাইটি",
        MenuUrl: "/bncc-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 86,
    },
    {
        Id: 87,
        ParentId: 7,
        MenuName: "Rover Scout Society",
        DisplayName: "Rover Scout Society",
        DisplayNameBangla: "রোভার স্কাউট সোসাইটি",
        MenuUrl: "/rover scout society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 87,
    },
    {
        Id: 88,
        ParentId: 7,
        MenuName: "Football Society",
        DisplayName: "Football Society",
        DisplayNameBangla: "ফুটবল সোসাইটি",
        MenuUrl: "/football-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 88,
    },
    {
        Id: 89,
        ParentId: 7,
        MenuName: "Cricket Society",
        DisplayName: "Cricket Society",
        DisplayNameBangla: "ক্রিকেট সোসাইটি",
        MenuUrl: "/cricket-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 89,
    },
    {
        Id: 90,
        ParentId: 9,
        MenuName: "Photo Gallery",
        DisplayName: "Photo Gallery",
        DisplayNameBangla: "ফটোস",
        MenuUrl: "/photo-gallery",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 90,
    },
    {
        Id: 91,
        ParentId: 9,
        MenuName: "Video Gallery",
        DisplayName: "Video Gallery",
        DisplayNameBangla: "ভিডিওস",
        MenuUrl: "/video-gallery",
        IsLeaf: true,
        FileType: 2,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 91,
    },
    {
        Id: 92,
        ParentId: 11,
        MenuName: "Student's Login",
        DisplayName: "Student's Login",
        DisplayNameBangla: "স্টুডেন্ট'স লগইন ",
        MenuUrl: "/student's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 92,
    },
    {
        Id: 93,
        ParentId: 11,
        MenuName: "Teacher's Login",
        DisplayName: "Teacher's Login",
        DisplayNameBangla: "টিচার'স লগইন ",
        MenuUrl: "/teacher's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 93,
    },
    {
        Id: 187,
        ParentId: 0,
        MenuName: "Home",
        DisplayName: "Home",
        DisplayNameBangla: "হোম ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 1,
    },
    {
        Id: 188,
        ParentId: 0,
        MenuName: "About Us ",
        DisplayName: "About Us ",
        DisplayNameBangla: "আমাদের সম্পর্কে",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 2,
    },
    {
        Id: 189,
        ParentId: 0,
        MenuName: "Academic ",
        DisplayName: "Academic ",
        DisplayNameBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 3,
    },
    {
        Id: 190,
        ParentId: 0,
        MenuName: "Admission ",
        DisplayName: "Admission ",
        DisplayNameBangla: "ভর্তি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 4,
    },
    {
        Id: 191,
        ParentId: 0,
        MenuName: "Administration  | Associates",
        DisplayName: "Administration  | Associates",
        DisplayNameBangla: "প্রশাসন | সহযোগী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 5,
    },
    {
        Id: 192,
        ParentId: 0,
        MenuName: "Result",
        DisplayName: "Result",
        DisplayNameBangla: "রেজাল্ট ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 6,
    },
    {
        Id: 193,
        ParentId: 0,
        MenuName: "Club & Scociety / Activites ",
        DisplayName: "Club & Scociety / Activites ",
        DisplayNameBangla: "ক্লাব",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 7,
    },
    {
        Id: 194,
        ParentId: 0,
        MenuName: "Golden Jubilee",
        DisplayName: "Golden Jubilee",
        DisplayNameBangla: "সুবর্ণ জয়ন্তী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 8,
    },
    {
        Id: 195,
        ParentId: 0,
        MenuName: "Gallery ",
        DisplayName: "Gallery ",
        DisplayNameBangla: "গ্যালারি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 9,
    },
    {
        Id: 196,
        ParentId: 0,
        MenuName: "Contact ",
        DisplayName: "Contact ",
        DisplayNameBangla: "যোগাযোগ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 10,
    },
    {
        Id: 197,
        ParentId: 0,
        MenuName: "Login ",
        DisplayName: "Login ",
        DisplayNameBangla: "লগ-ইন",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 11,
    },
    {
        Id: 198,
        ParentId: 2,
        MenuName: "At a Glance",
        DisplayName: "At a Glance",
        DisplayNameBangla: "এক নজরে ",
        MenuUrl: "/at-a-glance",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 12,
    },
    {
        Id: 199,
        ParentId: 2,
        MenuName: "History",
        DisplayName: "History",
        DisplayNameBangla: "ইতিহাস",
        MenuUrl: "/history",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 13,
    },
    {
        Id: 200,
        ParentId: 2,
        MenuName: "News And Events",
        DisplayName: "News And Events",
        DisplayNameBangla: "নিউস এন্ড ইভেন্টস ",
        MenuUrl: "/news-and-events",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 14,
    },
    {
        Id: 201,
        ParentId: 2,
        MenuName: "Why Study ",
        DisplayName: "Why Study ",
        DisplayNameBangla: "হোয়াই স্টাডি ",
        MenuUrl: "/why-study",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 15,
    },
    {
        Id: 202,
        ParentId: 2,
        MenuName: "Vision",
        DisplayName: "Vision",
        DisplayNameBangla: "ভিশন",
        MenuUrl: "/vision",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 16,
    },
    {
        Id: 203,
        ParentId: 2,
        MenuName: "Mission",
        DisplayName: "Mission",
        DisplayNameBangla: "মিশন",
        MenuUrl: "/mission",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 17,
    },
    {
        Id: 204,
        ParentId: 2,
        MenuName: "Achievements",
        DisplayName: "Achievements",
        DisplayNameBangla: "অর্জন  | এচিভমেন্টস ",
        MenuUrl: "/achievements",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 18,
    },
    {
        Id: 205,
        ParentId: 2,
        MenuName: "Oath",
        DisplayName: "Oath",
        DisplayNameBangla: "শপথ",
        MenuUrl: "/oath",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 19,
    },
    {
        Id: 206,
        ParentId: 2,
        MenuName: "Infustructure",
        DisplayName: "Infustructure",
        DisplayNameBangla: "অবকাঠামো",
        MenuUrl: "/infustructure",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 20,
    },
    {
        Id: 207,
        ParentId: 3,
        MenuName: "Academic Rules",
        DisplayName: "Academic Rules",
        DisplayNameBangla: "একাডেমিক নিয়ম",
        MenuUrl: "/academic-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 21,
    },
    {
        Id: 208,
        ParentId: 3,
        MenuName: "School Class Routine",
        DisplayName: "School Class Routine",
        DisplayNameBangla: "ক্লাস রুটিন | স্কুল ক্লাস রুটিন",
        MenuUrl: "/class-routine | /school-class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 22,
    },
    {
        Id: 209,
        ParentId: 3,
        MenuName: "College Class Routine",
        DisplayName: "College Class Routine",
        DisplayNameBangla: "কলেজের ক্লাস রুটিন",
        MenuUrl: "/college-class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 23,
    },
    {
        Id: 210,
        ParentId: 3,
        MenuName: "Lesson Plan",
        DisplayName: "Lesson Plan",
        DisplayNameBangla: "পাঠ পরিকল্পনা",
        MenuUrl: "/lesson-plan",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 24,
    },
    {
        Id: 211,
        ParentId: 3,
        MenuName: "Academic Calendar ",
        DisplayName: "Academic Calendar ",
        DisplayNameBangla: "শিক্ষা বর্ষপঞ্জি ",
        MenuUrl: "/academic-calendar ",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 25,
    },
    {
        Id: 212,
        ParentId: 3,
        MenuName: "Holiday Calendar",
        DisplayName: "Holiday Calendar",
        DisplayNameBangla: "ছুটির ক্যালেন্ডার",
        MenuUrl: "/holiday-calender",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 26,
    },
    {
        Id: 213,
        ParentId: 3,
        MenuName: "Notice",
        DisplayName: "Notice",
        DisplayNameBangla: "নোটিশ ",
        MenuUrl: "/notice",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 27,
    },
    {
        Id: 214,
        ParentId: 3,
        MenuName: "Course And Program",
        DisplayName: "Course And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/course-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 28,
    },
    {
        Id: 215,
        ParentId: 3,
        MenuName: "Syllabus And Booklist",
        DisplayName: "Syllabus And Booklist",
        DisplayNameBangla: "সিলেবাস এবং বুকলিস্ট",
        MenuUrl: "/syllabus-and-booklist",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 29,
    },
    {
        Id: 216,
        ParentId: 3,
        MenuName: "Prospectus",
        DisplayName: "Prospectus",
        DisplayNameBangla: "প্রসপেক্টাস",
        MenuUrl: "/prospectus",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 30,
    },
    {
        Id: 217,
        ParentId: 3,
        MenuName: "Magazine",
        DisplayName: "Magazine",
        DisplayNameBangla: "ম্যাগাজিন",
        MenuUrl: "/magazine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 31,
    },
    {
        Id: 218,
        ParentId: 3,
        MenuName: "Rules and Regulations",
        DisplayName: "Rules and Regulations",
        DisplayNameBangla: "নিয়ম এবং প্রবিধান",
        MenuUrl: "/rules-and-regulations",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 32,
    },
    {
        Id: 219,
        ParentId: 3,
        MenuName: "Uniform | School Uniform Info",
        DisplayName: "Uniform | School Uniform Info",
        DisplayNameBangla: "ইউনিফর্ম | স্কুল ইউনিফর্ম তথ্য",
        MenuUrl: "/uniform | /school-uniform-info",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 33,
    },
    {
        Id: 220,
        ParentId: 3,
        MenuName: "Suggestion | Suggestions To Parents",
        DisplayName: "Suggestion | Suggestions To Parents",
        DisplayNameBangla: "পরামর্শ | অভিভাবকদের পরামর্শ",
        MenuUrl: "/suggestion | /suggestions-to-parents",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 34,
    },
    {
        Id: 221,
        ParentId: 3,
        MenuName: "Other Information ",
        DisplayName: "Other Information ",
        DisplayNameBangla: "অন্যান্য",
        MenuUrl: "/online-information ",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 35,
    },
    {
        Id: 222,
        ParentId: 3,
        MenuName: "Coordinator",
        DisplayName: "Coordinator",
        DisplayNameBangla: "কোঅর্ডিনেটর ",
        MenuUrl: "/coordinator",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 36,
    },
    {
        Id: 223,
        ParentId: 3,
        MenuName: "Our Curriculum",
        DisplayName: "Our Curriculum",
        DisplayNameBangla: "আমাদের পাঠ্যক্রম",
        MenuUrl: "/our-curriculum",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 37,
    },
    {
        Id: 224,
        ParentId: 3,
        MenuName: "Extra-Co-Curricular",
        DisplayName: "Extra-Co-Curricular",
        DisplayNameBangla: "এক্সট্রা-কো-কারিকুলার",
        MenuUrl: "/extra-co-curricular",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 38,
    },
    {
        Id: 225,
        ParentId: 3,
        MenuName: "Class Time Schedule",
        DisplayName: "Class Time Schedule",
        DisplayNameBangla: "ক্লাসের সময়সূচী",
        MenuUrl: "/class-time-schedule",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 39,
    },
    {
        Id: 226,
        ParentId: 3,
        MenuName: "Club Activity",
        DisplayName: "Club Activity",
        DisplayNameBangla: "ক্লাব কার্যকলাপ",
        MenuUrl: "/club-activity",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 40,
    },
    {
        Id: 227,
        ParentId: 4,
        MenuName: "Admission Circular ",
        DisplayName: "Admission Circular ",
        DisplayNameBangla: "ভর্তি বিজ্ঞপ্তি ",
        MenuUrl: "/admission-circular |",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 41,
    },
    {
        Id: 228,
        ParentId: 4,
        MenuName: "Admission Form",
        DisplayName: "Admission Form",
        DisplayNameBangla: "ভর্তি ফরম",
        MenuUrl: "/admission-form",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 42,
    },
    {
        Id: 229,
        ParentId: 4,
        MenuName: "Selected Candidates",
        DisplayName: "Selected Candidates",
        DisplayNameBangla: "নির্বাচিত প্রার্থীরা",
        MenuUrl: "/selected-candidates",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 43,
    },
    {
        Id: 230,
        ParentId: 4,
        MenuName: "Waiting list",
        DisplayName: "Waiting list",
        DisplayNameBangla: "ওয়েটিং লিস্ট ",
        MenuUrl: "/waiting-list",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 44,
    },
    {
        Id: 231,
        ParentId: 4,
        MenuName: "Admission Result",
        DisplayName: "Admission Result",
        DisplayNameBangla: "ভর্তির ফলাফল",
        MenuUrl: "/admission-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 45,
    },
    {
        Id: 232,
        ParentId: 4,
        MenuName: "Exam Rules",
        DisplayName: "Exam Rules",
        DisplayNameBangla: "পরীক্ষার নিয়ম",
        MenuUrl: "/exam-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 46,
    },
    {
        Id: 233,
        ParentId: 4,
        MenuName: "Courses And Program",
        DisplayName: "Courses And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/courses-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 47,
    },
    {
        Id: 234,
        ParentId: 4,
        MenuName: "FAQ",
        DisplayName: "FAQ",
        DisplayNameBangla: "এফ এ কিউ ",
        MenuUrl: "/faq",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 48,
    },
    {
        Id: 235,
        ParentId: 4,
        MenuName: "Admission Procedure",
        DisplayName: "Admission Procedure",
        DisplayNameBangla: "ভর্তির পদ্ধতি",
        MenuUrl: "/admission-procedure",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 49,
    },
    {
        Id: 236,
        ParentId: 4,
        MenuName: "Payment Process",
        DisplayName: "Payment Process",
        DisplayNameBangla: "পেমেন্ট প্রক্রিয়া",
        MenuUrl: "/payment-process",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 50,
    },
    {
        Id: 237,
        ParentId: 4,
        MenuName: "Download Admit Card",
        DisplayName: "Download Admit Card",
        DisplayNameBangla: "অ্যাডমিট কার্ড ডাউনলোড",
        MenuUrl: "/download-admit-card",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 51,
    },
    {
        Id: 238,
        ParentId: 4,
        MenuName: "Admission Instruction",
        DisplayName: "Admission Instruction",
        DisplayNameBangla: "ভর্তির নির্দেশনা",
        MenuUrl: "/admission-instruction",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 52,
    },
    {
        Id: 239,
        ParentId: 5,
        MenuName: "Governing Body",
        DisplayName: "Governing Body",
        DisplayNameBangla: "পরিচালনা পর্ষদ",
        MenuUrl: "/governing-body",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 53,
    },
    {
        Id: 240,
        ParentId: 5,
        MenuName: "Message Of Chief Patron",
        DisplayName: "Message Of Chief Patron",
        DisplayNameBangla: "প্রধান পৃষ্ঠপোষক বার্তা",
        MenuUrl: "/message-of-chief-patron",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 54,
    },
    {
        Id: 241,
        ParentId: 5,
        MenuName: "Message Of Chairman ",
        DisplayName: "Message Of Chairman ",
        DisplayNameBangla: "চেয়ারম্যানের বার্তা",
        MenuUrl: "/message-of-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 55,
    },
    {
        Id: 242,
        ParentId: 5,
        MenuName: "Message of Vice Chairman",
        DisplayName: "Message of Vice Chairman",
        DisplayNameBangla: "ভাইস চেয়ারম্যানের বার্তা",
        MenuUrl: "/message-of-vice-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 56,
    },
    {
        Id: 243,
        ParentId: 5,
        MenuName: "Message of Principal",
        DisplayName: "Message of Principal",
        DisplayNameBangla: "অধ্যক্ষের বার্তা",
        MenuUrl: "/message-of-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 57,
    },
    {
        Id: 244,
        ParentId: 5,
        MenuName: "Message Of Vice Principal",
        DisplayName: "Message Of Vice Principal",
        DisplayNameBangla: "ভাইস প্রিন্সিপালের বার্তা",
        MenuUrl: "/message-of-vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 58,
    },
    {
        Id: 245,
        ParentId: 5,
        MenuName: "Student Advisor",
        DisplayName: "Student Advisor",
        DisplayNameBangla: "ছাত্র-ছাত্রীদের উপদেষ্টা",
        MenuUrl: "/student-advisor",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 59,
    },
    {
        Id: 246,
        ParentId: 5,
        MenuName: "Academic Organogram",
        DisplayName: "Academic Organogram",
        DisplayNameBangla: "একাডেমিক অর্গানোগ্রাম",
        MenuUrl: "/academic-organogram",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 60,
    },
    {
        Id: 247,
        ParentId: 5,
        MenuName: "Ex-Chairman | Chairman",
        DisplayName: "Ex-Chairman | Chairman",
        DisplayNameBangla: "প্রাক্তন চেয়ারম্যান | চেয়ারম্যান",
        MenuUrl: "/ex-chairman | /chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 61,
    },
    {
        Id: 248,
        ParentId: 5,
        MenuName: "Ex-Principals | Principal",
        DisplayName: "Ex-Principals | Principal",
        DisplayNameBangla: "প্রাক্তন অধ্যক্ষ | অধ্যক্ষ",
        MenuUrl: "/ex-principals | /principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 62,
    },
    {
        Id: 249,
        ParentId: 5,
        MenuName: "Ex-Vice Principals | Vice Principal",
        DisplayName: "Ex-Vice Principals | Vice Principal",
        DisplayNameBangla: "প্রাক্তন ভাইস প্রিন্সিপাল | ভাইস প্রিন্সিপাল",
        MenuUrl: "/ex-vice-principals | /vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 63,
    },
    {
        Id: 250,
        ParentId: 5,
        MenuName: "Ex-Teacher",
        DisplayName: "Ex-Teacher",
        DisplayNameBangla: "প্রাক্তন শিক্ষক",
        MenuUrl: "/ex-teacher",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 64,
    },
    {
        Id: 251,
        ParentId: 5,
        MenuName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayNameBangla: "শিক্ষকমন্ডলী (স্কুল শাখা))",
        MenuUrl: "/teacher-information",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 65,
    },
    {
        Id: 252,
        ParentId: 5,
        MenuName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayNameBangla: "শিক্ষকমন্ডলী (কলেজ শাখা)",
        MenuUrl: "/teacher's-list-college | /teacher-information-grils-section",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 66,
    },
    {
        Id: 253,
        ParentId: 5,
        MenuName: "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayName:
            "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayNameBangla: "কর্মচারীর তালিকা",
        MenuUrl: "/staff-information | /officers-&-staffs-list | /non-teaching",
        IsLeaf: true,
        FileType: 6,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 67,
    },
    {
        Id: 254,
        ParentId: 6,
        MenuName: "Institution Result",
        DisplayName: "Institution Result",
        DisplayNameBangla: "প্রতিষ্ঠানের ফলাফল",
        MenuUrl: "/institution-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 68,
    },
    {
        Id: 255,
        ParentId: 6,
        MenuName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayNameBangla: "বোর্ডের ফলাফল | এইচএসসি ফলাফল | এসএসসি ফলাফল",
        MenuUrl: "/board-result | /hsc-results | /ssc-results",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 69,
    },
    {
        Id: 256,
        ParentId: 6,
        MenuName: "Scholarship Result",
        DisplayName: "Scholarship Result",
        DisplayNameBangla: "বৃত্তি ফলাফল",
        MenuUrl: "/scholarship-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 70,
    },
    {
        Id: 257,
        ParentId: 6,
        MenuName: "Admission Test Result",
        DisplayName: "Admission Test Result",
        DisplayNameBangla: "ভর্তি পরীক্ষার ফলাফল",
        MenuUrl: "/admission-test-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 71,
    },
    {
        Id: 258,
        ParentId: 6,
        MenuName: "Recruitment",
        DisplayName: "Recruitment",
        DisplayNameBangla: "নিয়োগ | রিক্রুটমেন্ট",
        MenuUrl: "/recruitment",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 72,
    },
    {
        Id: 259,
        ParentId: 6,
        MenuName: "Recruitment Result",
        DisplayName: "Recruitment Result",
        DisplayNameBangla: "নিয়োগের ফলাফল | রিক্রুটমেন্ট ফলাফল ",
        MenuUrl: "/recruitment-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 73,
    },
    {
        Id: 260,
        ParentId: 7,
        MenuName: "Cultural Club",
        DisplayName: "Cultural Club",
        DisplayNameBangla: "সাংস্কৃতিক ক্লাব",
        MenuUrl: "/cultural-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 74,
    },
    {
        Id: 261,
        ParentId: 7,
        MenuName: "Quiz club",
        DisplayName: "Quiz club",
        DisplayNameBangla: "কুইজ ক্লাব",
        MenuUrl: "/quiz-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 75,
    },
    {
        Id: 262,
        ParentId: 7,
        MenuName: "IT club",
        DisplayName: "IT club",
        DisplayNameBangla: "আইটি ক্লাব",
        MenuUrl: "/it-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 76,
    },
    {
        Id: 263,
        ParentId: 7,
        MenuName: "Business club",
        DisplayName: "Business club",
        DisplayNameBangla: "ব্যবসায়িক ক্লাব",
        MenuUrl: "/business-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 77,
    },
    {
        Id: 264,
        ParentId: 7,
        MenuName: "Blood Donation club",
        DisplayName: "Blood Donation club",
        DisplayNameBangla: "রক্তদান ক্লাব",
        MenuUrl: "/blood-donation-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 78,
    },
    {
        Id: 265,
        ParentId: 7,
        MenuName: "Quran Learning Club",
        DisplayName: "Quran Learning Club",
        DisplayNameBangla: "কোরআন লার্নিং ক্লাব",
        MenuUrl: "/quran-learning-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 79,
    },
    {
        Id: 266,
        ParentId: 7,
        MenuName: "General Knowledge Club",
        DisplayName: "General Knowledge Club",
        DisplayNameBangla: "সাধারণ জ্ঞান ক্লাব",
        MenuUrl: "/general-knowledge-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 80,
    },
    {
        Id: 267,
        ParentId: 7,
        MenuName: "Language Club",
        DisplayName: "Language Club",
        DisplayNameBangla: "ভাষা ক্লাব",
        MenuUrl: "/language-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 81,
    },
    {
        Id: 268,
        ParentId: 7,
        MenuName: "Sports & Karate Club",
        DisplayName: "Sports & Karate Club",
        DisplayNameBangla: "ক্রীড়া ও কারাতে ক্লাব",
        MenuUrl: "/sports-&-karate-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 82,
    },
    {
        Id: 269,
        ParentId: 7,
        MenuName: "Science Club:",
        DisplayName: "Science Club:",
        DisplayNameBangla: "বিজ্ঞান ক্লাব:",
        MenuUrl: "",
        IsLeaf: false,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 83,
    },
    {
        Id: 270,
        ParentId: 7,
        MenuName: "Physics",
        DisplayName: "Physics",
        DisplayNameBangla: "পদার্থ-বিজ্ঞান",
        MenuUrl: "/physics",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 84,
    },
    {
        Id: 271,
        ParentId: 7,
        MenuName: "Chemistry",
        DisplayName: "Chemistry",
        DisplayNameBangla: "রসায়ন",
        MenuUrl: "/chemistry",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 85,
    },
    {
        Id: 272,
        ParentId: 7,
        MenuName: "BNCC Society",
        DisplayName: "BNCC Society",
        DisplayNameBangla: "বিএনসিসি সোসাইটি",
        MenuUrl: "/bncc-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 86,
    },
    {
        Id: 273,
        ParentId: 7,
        MenuName: "Rover Scout Society",
        DisplayName: "Rover Scout Society",
        DisplayNameBangla: "রোভার স্কাউট সোসাইটি",
        MenuUrl: "/rover scout society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 87,
    },
    {
        Id: 274,
        ParentId: 7,
        MenuName: "Football Society",
        DisplayName: "Football Society",
        DisplayNameBangla: "ফুটবল সোসাইটি",
        MenuUrl: "/football-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 88,
    },
    {
        Id: 275,
        ParentId: 7,
        MenuName: "Cricket Society",
        DisplayName: "Cricket Society",
        DisplayNameBangla: "ক্রিকেট সোসাইটি",
        MenuUrl: "/cricket-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 89,
    },
    {
        Id: 276,
        ParentId: 9,
        MenuName: "Photo Gallery",
        DisplayName: "Photo Gallery",
        DisplayNameBangla: "ফটোস",
        MenuUrl: "/photo-gallery",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 90,
    },
    {
        Id: 277,
        ParentId: 9,
        MenuName: "Video Gallery",
        DisplayName: "Video Gallery",
        DisplayNameBangla: "ভিডিওস",
        MenuUrl: "/video-gallery",
        IsLeaf: true,
        FileType: 2,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 91,
    },
    {
        Id: 278,
        ParentId: 11,
        MenuName: "Student's Login",
        DisplayName: "Student's Login",
        DisplayNameBangla: "স্টুডেন্ট'স লগইন ",
        MenuUrl: "/student's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 92,
    },
    {
        Id: 279,
        ParentId: 11,
        MenuName: "Teacher's Login",
        DisplayName: "Teacher's Login",
        DisplayNameBangla: "টিচার'স লগইন ",
        MenuUrl: "/teacher's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 93,
    },
    {
        Id: 280,
        ParentId: 0,
        MenuName: "Home",
        DisplayName: "Home",
        DisplayNameBangla: "হোম ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 1,
    },
    {
        Id: 281,
        ParentId: 0,
        MenuName: "About Us ",
        DisplayName: "About Us ",
        DisplayNameBangla: "আমাদের সম্পর্কে",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 2,
    },
    {
        Id: 282,
        ParentId: 0,
        MenuName: "Academic ",
        DisplayName: "Academic ",
        DisplayNameBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 3,
    },
    {
        Id: 283,
        ParentId: 0,
        MenuName: "Admission ",
        DisplayName: "Admission ",
        DisplayNameBangla: "ভর্তি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 4,
    },
    {
        Id: 284,
        ParentId: 0,
        MenuName: "Administration  | Associates",
        DisplayName: "Administration  | Associates",
        DisplayNameBangla: "প্রশাসন | সহযোগী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 5,
    },
    {
        Id: 285,
        ParentId: 0,
        MenuName: "Result",
        DisplayName: "Result",
        DisplayNameBangla: "রেজাল্ট ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 6,
    },
    {
        Id: 286,
        ParentId: 0,
        MenuName: "Club & Scociety / Activites ",
        DisplayName: "Club & Scociety / Activites ",
        DisplayNameBangla: "ক্লাব",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 7,
    },
    {
        Id: 287,
        ParentId: 0,
        MenuName: "Golden Jubilee",
        DisplayName: "Golden Jubilee",
        DisplayNameBangla: "সুবর্ণ জয়ন্তী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 8,
    },
    {
        Id: 288,
        ParentId: 0,
        MenuName: "Gallery ",
        DisplayName: "Gallery ",
        DisplayNameBangla: "গ্যালারি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 9,
    },
    {
        Id: 289,
        ParentId: 0,
        MenuName: "Contact ",
        DisplayName: "Contact ",
        DisplayNameBangla: "যোগাযোগ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 10,
    },
    {
        Id: 290,
        ParentId: 0,
        MenuName: "Login ",
        DisplayName: "Login ",
        DisplayNameBangla: "লগ-ইন",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 11,
    },
    {
        Id: 291,
        ParentId: 281,
        MenuName: "At a Glance",
        DisplayName: "At a Glance",
        DisplayNameBangla: "এক নজরে ",
        MenuUrl: "/at-a-glance",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 12,
    },
    {
        Id: 292,
        ParentId: 281,
        MenuName: "History",
        DisplayName: "History",
        DisplayNameBangla: "ইতিহাস",
        MenuUrl: "/history",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 13,
    },
    {
        Id: 293,
        ParentId: 281,
        MenuName: "News And Events",
        DisplayName: "News And Events",
        DisplayNameBangla: "নিউস এন্ড ইভেন্টস ",
        MenuUrl: "/news-and-events",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 14,
    },
    {
        Id: 294,
        ParentId: 281,
        MenuName: "Why Study ",
        DisplayName: "Why Study ",
        DisplayNameBangla: "হোয়াই স্টাডি ",
        MenuUrl: "/why-study",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 15,
    },
    {
        Id: 295,
        ParentId: 281,
        MenuName: "Vision",
        DisplayName: "Vision",
        DisplayNameBangla: "ভিশন",
        MenuUrl: "/vision",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 16,
    },
    {
        Id: 296,
        ParentId: 281,
        MenuName: "Mission",
        DisplayName: "Mission",
        DisplayNameBangla: "মিশন",
        MenuUrl: "/mission",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 17,
    },
    {
        Id: 297,
        ParentId: 281,
        MenuName: "Achievements",
        DisplayName: "Achievements",
        DisplayNameBangla: "অর্জন  | এচিভমেন্টস ",
        MenuUrl: "/achievements",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 18,
    },
    {
        Id: 298,
        ParentId: 281,
        MenuName: "Oath",
        DisplayName: "Oath",
        DisplayNameBangla: "শপথ",
        MenuUrl: "/oath",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 19,
    },
    {
        Id: 299,
        ParentId: 281,
        MenuName: "Infustructure",
        DisplayName: "Infustructure",
        DisplayNameBangla: "অবকাঠামো",
        MenuUrl: "/infustructure",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 20,
    },
    {
        Id: 300,
        ParentId: 282,
        MenuName: "Academic Rules",
        DisplayName: "Academic Rules",
        DisplayNameBangla: "একাডেমিক নিয়ম",
        MenuUrl: "/academic-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 21,
    },
    {
        Id: 301,
        ParentId: 282,
        MenuName: "School Class Routine",
        DisplayName: "School Class Routine",
        DisplayNameBangla: "ক্লাস রুটিন | স্কুল ক্লাস রুটিন",
        MenuUrl: "/class-routine | /school-class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 22,
    },
    {
        Id: 302,
        ParentId: 282,
        MenuName: "College Class Routine",
        DisplayName: "College Class Routine",
        DisplayNameBangla: "কলেজের ক্লাস রুটিন",
        MenuUrl: "/college-class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 23,
    },
    {
        Id: 303,
        ParentId: 282,
        MenuName: "Lesson Plan",
        DisplayName: "Lesson Plan",
        DisplayNameBangla: "পাঠ পরিকল্পনা",
        MenuUrl: "/lesson-plan",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 24,
    },
    {
        Id: 304,
        ParentId: 282,
        MenuName: "Academic Calendar ",
        DisplayName: "Academic Calendar ",
        DisplayNameBangla: "শিক্ষা বর্ষপঞ্জি ",
        MenuUrl: "/academic-calendar ",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 25,
    },
    {
        Id: 305,
        ParentId: 282,
        MenuName: "Holiday Calendar",
        DisplayName: "Holiday Calendar",
        DisplayNameBangla: "ছুটির ক্যালেন্ডার",
        MenuUrl: "/holiday-calender",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 26,
    },
    {
        Id: 306,
        ParentId: 282,
        MenuName: "Notice",
        DisplayName: "Notice",
        DisplayNameBangla: "নোটিশ ",
        MenuUrl: "/notice",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 27,
    },
    {
        Id: 307,
        ParentId: 282,
        MenuName: "Course And Program",
        DisplayName: "Course And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/course-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 28,
    },
    {
        Id: 308,
        ParentId: 282,
        MenuName: "Syllabus And Booklist",
        DisplayName: "Syllabus And Booklist",
        DisplayNameBangla: "সিলেবাস এবং বুকলিস্ট",
        MenuUrl: "/syllabus-and-booklist",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 29,
    },
    {
        Id: 309,
        ParentId: 282,
        MenuName: "Prospectus",
        DisplayName: "Prospectus",
        DisplayNameBangla: "প্রসপেক্টাস",
        MenuUrl: "/prospectus",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 30,
    },
    {
        Id: 310,
        ParentId: 282,
        MenuName: "Magazine",
        DisplayName: "Magazine",
        DisplayNameBangla: "ম্যাগাজিন",
        MenuUrl: "/magazine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 31,
    },
    {
        Id: 311,
        ParentId: 282,
        MenuName: "Rules and Regulations",
        DisplayName: "Rules and Regulations",
        DisplayNameBangla: "নিয়ম এবং প্রবিধান",
        MenuUrl: "/rules-and-regulations",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 32,
    },
    {
        Id: 312,
        ParentId: 282,
        MenuName: "Uniform | School Uniform Info",
        DisplayName: "Uniform | School Uniform Info",
        DisplayNameBangla: "ইউনিফর্ম | স্কুল ইউনিফর্ম তথ্য",
        MenuUrl: "/uniform | /school-uniform-info",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 33,
    },
    {
        Id: 313,
        ParentId: 282,
        MenuName: "Suggestion | Suggestions To Parents",
        DisplayName: "Suggestion | Suggestions To Parents",
        DisplayNameBangla: "পরামর্শ | অভিভাবকদের পরামর্শ",
        MenuUrl: "/suggestion | /suggestions-to-parents",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 34,
    },
    {
        Id: 314,
        ParentId: 282,
        MenuName: "Other Information ",
        DisplayName: "Other Information ",
        DisplayNameBangla: "অন্যান্য",
        MenuUrl: "/online-information ",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 35,
    },
    {
        Id: 315,
        ParentId: 282,
        MenuName: "Coordinator",
        DisplayName: "Coordinator",
        DisplayNameBangla: "কোঅর্ডিনেটর ",
        MenuUrl: "/coordinator",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 36,
    },
    {
        Id: 316,
        ParentId: 282,
        MenuName: "Our Curriculum",
        DisplayName: "Our Curriculum",
        DisplayNameBangla: "আমাদের পাঠ্যক্রম",
        MenuUrl: "/our-curriculum",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 37,
    },
    {
        Id: 317,
        ParentId: 282,
        MenuName: "Extra-Co-Curricular",
        DisplayName: "Extra-Co-Curricular",
        DisplayNameBangla: "এক্সট্রা-কো-কারিকুলার",
        MenuUrl: "/extra-co-curricular",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 38,
    },
    {
        Id: 318,
        ParentId: 282,
        MenuName: "Class Time Schedule",
        DisplayName: "Class Time Schedule",
        DisplayNameBangla: "ক্লাসের সময়সূচী",
        MenuUrl: "/class-time-schedule",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 39,
    },
    {
        Id: 319,
        ParentId: 282,
        MenuName: "Club Activity",
        DisplayName: "Club Activity",
        DisplayNameBangla: "ক্লাব কার্যকলাপ",
        MenuUrl: "/club-activity",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 40,
    },
    {
        Id: 320,
        ParentId: 283,
        MenuName: "Admission Circular ",
        DisplayName: "Admission Circular ",
        DisplayNameBangla: "ভর্তি বিজ্ঞপ্তি ",
        MenuUrl: "/admission-circular |",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 41,
    },
    {
        Id: 321,
        ParentId: 283,
        MenuName: "Admission Form",
        DisplayName: "Admission Form",
        DisplayNameBangla: "ভর্তি ফরম",
        MenuUrl: "/admission-form",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 42,
    },
    {
        Id: 322,
        ParentId: 283,
        MenuName: "Selected Candidates",
        DisplayName: "Selected Candidates",
        DisplayNameBangla: "নির্বাচিত প্রার্থীরা",
        MenuUrl: "/selected-candidates",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 43,
    },
    {
        Id: 323,
        ParentId: 283,
        MenuName: "Waiting list",
        DisplayName: "Waiting list",
        DisplayNameBangla: "ওয়েটিং লিস্ট ",
        MenuUrl: "/waiting-list",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 44,
    },
    {
        Id: 324,
        ParentId: 283,
        MenuName: "Admission Result",
        DisplayName: "Admission Result",
        DisplayNameBangla: "ভর্তির ফলাফল",
        MenuUrl: "/admission-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 45,
    },
    {
        Id: 325,
        ParentId: 283,
        MenuName: "Exam Rules",
        DisplayName: "Exam Rules",
        DisplayNameBangla: "পরীক্ষার নিয়ম",
        MenuUrl: "/exam-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 46,
    },
    {
        Id: 326,
        ParentId: 283,
        MenuName: "Courses And Program",
        DisplayName: "Courses And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/courses-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 47,
    },
    {
        Id: 327,
        ParentId: 283,
        MenuName: "FAQ",
        DisplayName: "FAQ",
        DisplayNameBangla: "এফ এ কিউ ",
        MenuUrl: "/faq",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 48,
    },
    {
        Id: 328,
        ParentId: 283,
        MenuName: "Admission Procedure",
        DisplayName: "Admission Procedure",
        DisplayNameBangla: "ভর্তির পদ্ধতি",
        MenuUrl: "/admission-procedure",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 49,
    },
    {
        Id: 329,
        ParentId: 283,
        MenuName: "Payment Process",
        DisplayName: "Payment Process",
        DisplayNameBangla: "পেমেন্ট প্রক্রিয়া",
        MenuUrl: "/payment-process",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 50,
    },
    {
        Id: 330,
        ParentId: 283,
        MenuName: "Download Admit Card",
        DisplayName: "Download Admit Card",
        DisplayNameBangla: "অ্যাডমিট কার্ড ডাউনলোড",
        MenuUrl: "/download-admit-card",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 51,
    },
    {
        Id: 331,
        ParentId: 283,
        MenuName: "Admission Instruction",
        DisplayName: "Admission Instruction",
        DisplayNameBangla: "ভর্তির নির্দেশনা",
        MenuUrl: "/admission-instruction",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 52,
    },
    {
        Id: 332,
        ParentId: 284,
        MenuName: "Governing Body",
        DisplayName: "Governing Body",
        DisplayNameBangla: "পরিচালনা পর্ষদ",
        MenuUrl: "/governing-body",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 53,
    },
    {
        Id: 333,
        ParentId: 284,
        MenuName: "Message Of Chief Patron",
        DisplayName: "Message Of Chief Patron",
        DisplayNameBangla: "প্রধান পৃষ্ঠপোষক বার্তা",
        MenuUrl: "/message-of-chief-patron",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 54,
    },
    {
        Id: 334,
        ParentId: 284,
        MenuName: "Message Of Chairman ",
        DisplayName: "Message Of Chairman ",
        DisplayNameBangla: "চেয়ারম্যানের বার্তা",
        MenuUrl: "/message-of-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 55,
    },
    {
        Id: 335,
        ParentId: 284,
        MenuName: "Message of Vice Chairman",
        DisplayName: "Message of Vice Chairman",
        DisplayNameBangla: "ভাইস চেয়ারম্যানের বার্তা",
        MenuUrl: "/message-of-vice-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 56,
    },
    {
        Id: 336,
        ParentId: 284,
        MenuName: "Message of Principal",
        DisplayName: "Message of Principal",
        DisplayNameBangla: "অধ্যক্ষের বার্তা",
        MenuUrl: "/message-of-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 57,
    },
    {
        Id: 337,
        ParentId: 284,
        MenuName: "Message Of Vice Principal",
        DisplayName: "Message Of Vice Principal",
        DisplayNameBangla: "ভাইস প্রিন্সিপালের বার্তা",
        MenuUrl: "/message-of-vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 58,
    },
    {
        Id: 338,
        ParentId: 284,
        MenuName: "Student Advisor",
        DisplayName: "Student Advisor",
        DisplayNameBangla: "ছাত্র-ছাত্রীদের উপদেষ্টা",
        MenuUrl: "/student-advisor",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 59,
    },
    {
        Id: 339,
        ParentId: 284,
        MenuName: "Academic Organogram",
        DisplayName: "Academic Organogram",
        DisplayNameBangla: "একাডেমিক অর্গানোগ্রাম",
        MenuUrl: "/academic-organogram",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 60,
    },
    {
        Id: 340,
        ParentId: 284,
        MenuName: "Ex-Chairman | Chairman",
        DisplayName: "Ex-Chairman | Chairman",
        DisplayNameBangla: "প্রাক্তন চেয়ারম্যান | চেয়ারম্যান",
        MenuUrl: "/ex-chairman | /chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 61,
    },
    {
        Id: 341,
        ParentId: 284,
        MenuName: "Ex-Principals | Principal",
        DisplayName: "Ex-Principals | Principal",
        DisplayNameBangla: "প্রাক্তন অধ্যক্ষ | অধ্যক্ষ",
        MenuUrl: "/ex-principals | /principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 62,
    },
    {
        Id: 342,
        ParentId: 284,
        MenuName: "Ex-Vice Principals | Vice Principal",
        DisplayName: "Ex-Vice Principals | Vice Principal",
        DisplayNameBangla: "প্রাক্তন ভাইস প্রিন্সিপাল | ভাইস প্রিন্সিপাল",
        MenuUrl: "/ex-vice-principals | /vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 63,
    },
    {
        Id: 343,
        ParentId: 284,
        MenuName: "Ex-Teacher",
        DisplayName: "Ex-Teacher",
        DisplayNameBangla: "প্রাক্তন শিক্ষক",
        MenuUrl: "/ex-teacher",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 64,
    },
    {
        Id: 344,
        ParentId: 284,
        MenuName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayNameBangla: "শিক্ষকমন্ডলী (স্কুল শাখা))",
        MenuUrl: "/teacher-information",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 65,
    },
    {
        Id: 345,
        ParentId: 284,
        MenuName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayNameBangla: "শিক্ষকমন্ডলী (কলেজ শাখা)",
        MenuUrl: "/teacher's-list-college | /teacher-information-grils-section",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 66,
    },
    {
        Id: 346,
        ParentId: 284,
        MenuName: "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayName:
            "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayNameBangla: "কর্মচারীর তালিকা",
        MenuUrl: "/staff-information | /officers-&-staffs-list | /non-teaching",
        IsLeaf: true,
        FileType: 6,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 67,
    },
    {
        Id: 347,
        ParentId: 285,
        MenuName: "Institution Result",
        DisplayName: "Institution Result",
        DisplayNameBangla: "প্রতিষ্ঠানের ফলাফল",
        MenuUrl: "/institution-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 68,
    },
    {
        Id: 348,
        ParentId: 285,
        MenuName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayNameBangla: "বোর্ডের ফলাফল | এইচএসসি ফলাফল | এসএসসি ফলাফল",
        MenuUrl: "/board-result | /hsc-results | /ssc-results",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 69,
    },
    {
        Id: 349,
        ParentId: 285,
        MenuName: "Scholarship Result",
        DisplayName: "Scholarship Result",
        DisplayNameBangla: "বৃত্তি ফলাফল",
        MenuUrl: "/scholarship-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 70,
    },
    {
        Id: 350,
        ParentId: 285,
        MenuName: "Admission Test Result",
        DisplayName: "Admission Test Result",
        DisplayNameBangla: "ভর্তি পরীক্ষার ফলাফল",
        MenuUrl: "/admission-test-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 71,
    },
    {
        Id: 351,
        ParentId: 285,
        MenuName: "Recruitment",
        DisplayName: "Recruitment",
        DisplayNameBangla: "নিয়োগ | রিক্রুটমেন্ট",
        MenuUrl: "/recruitment",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 72,
    },
    {
        Id: 352,
        ParentId: 285,
        MenuName: "Recruitment Result",
        DisplayName: "Recruitment Result",
        DisplayNameBangla: "নিয়োগের ফলাফল | রিক্রুটমেন্ট ফলাফল ",
        MenuUrl: "/recruitment-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 73,
    },
    {
        Id: 353,
        ParentId: 286,
        MenuName: "Cultural Club",
        DisplayName: "Cultural Club",
        DisplayNameBangla: "সাংস্কৃতিক ক্লাব",
        MenuUrl: "/cultural-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 74,
    },
    {
        Id: 354,
        ParentId: 286,
        MenuName: "Quiz club",
        DisplayName: "Quiz club",
        DisplayNameBangla: "কুইজ ক্লাব",
        MenuUrl: "/quiz-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 75,
    },
    {
        Id: 355,
        ParentId: 286,
        MenuName: "IT club",
        DisplayName: "IT club",
        DisplayNameBangla: "আইটি ক্লাব",
        MenuUrl: "/it-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 76,
    },
    {
        Id: 356,
        ParentId: 286,
        MenuName: "Business club",
        DisplayName: "Business club",
        DisplayNameBangla: "ব্যবসায়িক ক্লাব",
        MenuUrl: "/business-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 77,
    },
    {
        Id: 357,
        ParentId: 286,
        MenuName: "Blood Donation club",
        DisplayName: "Blood Donation club",
        DisplayNameBangla: "রক্তদান ক্লাব",
        MenuUrl: "/blood-donation-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 78,
    },
    {
        Id: 358,
        ParentId: 286,
        MenuName: "Quran Learning Club",
        DisplayName: "Quran Learning Club",
        DisplayNameBangla: "কোরআন লার্নিং ক্লাব",
        MenuUrl: "/quran-learning-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 79,
    },
    {
        Id: 359,
        ParentId: 286,
        MenuName: "General Knowledge Club",
        DisplayName: "General Knowledge Club",
        DisplayNameBangla: "সাধারণ জ্ঞান ক্লাব",
        MenuUrl: "/general-knowledge-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 80,
    },
    {
        Id: 360,
        ParentId: 286,
        MenuName: "Language Club",
        DisplayName: "Language Club",
        DisplayNameBangla: "ভাষা ক্লাব",
        MenuUrl: "/language-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 81,
    },
    {
        Id: 361,
        ParentId: 286,
        MenuName: "Sports & Karate Club",
        DisplayName: "Sports & Karate Club",
        DisplayNameBangla: "ক্রীড়া ও কারাতে ক্লাব",
        MenuUrl: "/sports-&-karate-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 82,
    },
    {
        Id: 362,
        ParentId: 286,
        MenuName: "Science Club:",
        DisplayName: "Science Club:",
        DisplayNameBangla: "বিজ্ঞান ক্লাব:",
        MenuUrl: "",
        IsLeaf: false,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 83,
    },
    {
        Id: 363,
        ParentId: 286,
        MenuName: "Physics",
        DisplayName: "Physics",
        DisplayNameBangla: "পদার্থ-বিজ্ঞান",
        MenuUrl: "/physics",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 84,
    },
    {
        Id: 364,
        ParentId: 286,
        MenuName: "Chemistry",
        DisplayName: "Chemistry",
        DisplayNameBangla: "রসায়ন",
        MenuUrl: "/chemistry",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 85,
    },
    {
        Id: 365,
        ParentId: 286,
        MenuName: "BNCC Society",
        DisplayName: "BNCC Society",
        DisplayNameBangla: "বিএনসিসি সোসাইটি",
        MenuUrl: "/bncc-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 86,
    },
    {
        Id: 366,
        ParentId: 286,
        MenuName: "Rover Scout Society",
        DisplayName: "Rover Scout Society",
        DisplayNameBangla: "রোভার স্কাউট সোসাইটি",
        MenuUrl: "/rover scout society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 87,
    },
    {
        Id: 367,
        ParentId: 286,
        MenuName: "Football Society",
        DisplayName: "Football Society",
        DisplayNameBangla: "ফুটবল সোসাইটি",
        MenuUrl: "/football-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 88,
    },
    {
        Id: 368,
        ParentId: 286,
        MenuName: "Cricket Society",
        DisplayName: "Cricket Society",
        DisplayNameBangla: "ক্রিকেট সোসাইটি",
        MenuUrl: "/cricket-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 89,
    },
    {
        Id: 369,
        ParentId: 288,
        MenuName: "Photo Gallery",
        DisplayName: "Photo Gallery",
        DisplayNameBangla: "ফটোস",
        MenuUrl: "/photo-gallery",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 90,
    },
    {
        Id: 370,
        ParentId: 288,
        MenuName: "Video Gallery",
        DisplayName: "Video Gallery",
        DisplayNameBangla: "ভিডিওস",
        MenuUrl: "/video-gallery",
        IsLeaf: true,
        FileType: 2,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 91,
    },
    {
        Id: 371,
        ParentId: 290,
        MenuName: "Student's Login",
        DisplayName: "Student's Login",
        DisplayNameBangla: "স্টুডেন্ট'স লগইন ",
        MenuUrl: "/student's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 92,
    },
    {
        Id: 372,
        ParentId: 290,
        MenuName: "Teacher's Login",
        DisplayName: "Teacher's Login",
        DisplayNameBangla: "টিচার'স লগইন ",
        MenuUrl: "/teacher's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 93,
    },
    {
        Id: 373,
        ParentId: 0,
        MenuName: "Home",
        DisplayName: "Home",
        DisplayNameBangla: "হোম ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 1,
    },
    {
        Id: 374,
        ParentId: 0,
        MenuName: "About Us ",
        DisplayName: "About Us ",
        DisplayNameBangla: "আমাদের সম্পর্কে",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 2,
    },
    {
        Id: 375,
        ParentId: 0,
        MenuName: "Academic ",
        DisplayName: "Academic ",
        DisplayNameBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 3,
    },
    {
        Id: 376,
        ParentId: 0,
        MenuName: "Admission ",
        DisplayName: "Admission ",
        DisplayNameBangla: "ভর্তি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 4,
    },
    {
        Id: 377,
        ParentId: 0,
        MenuName: "Administration  | Associates",
        DisplayName: "Administration  | Associates",
        DisplayNameBangla: "প্রশাসন | সহযোগী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 5,
    },
    {
        Id: 378,
        ParentId: 0,
        MenuName: "Result",
        DisplayName: "Result",
        DisplayNameBangla: "রেজাল্ট ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 6,
    },
    {
        Id: 379,
        ParentId: 0,
        MenuName: "Club & Scociety / Activites ",
        DisplayName: "Club & Scociety / Activites ",
        DisplayNameBangla: "ক্লাব",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 7,
    },
    {
        Id: 380,
        ParentId: 0,
        MenuName: "Golden Jubilee",
        DisplayName: "Golden Jubilee",
        DisplayNameBangla: "সুবর্ণ জয়ন্তী",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 8,
    },
    {
        Id: 381,
        ParentId: 0,
        MenuName: "Gallery ",
        DisplayName: "Gallery ",
        DisplayNameBangla: "গ্যালারি",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 9,
    },
    {
        Id: 382,
        ParentId: 0,
        MenuName: "Contact ",
        DisplayName: "Contact ",
        DisplayNameBangla: "যোগাযোগ",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 10,
    },
    {
        Id: 383,
        ParentId: 0,
        MenuName: "Login ",
        DisplayName: "Login ",
        DisplayNameBangla: "লগ-ইন",
        MenuUrl: "#",
        IsLeaf: false,
        FileType: 0,
        LayoutType: 0,
        DisplayNameParent: "",
        DisplayNameParentBangla: "",
        MenuOrder: null,
        MenuCode: 11,
    },
    {
        Id: 384,
        ParentId: 374,
        MenuName: "At a Glance",
        DisplayName: "At a Glance",
        DisplayNameBangla: "এক নজরে ",
        MenuUrl: "/at-a-glance",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 12,
    },
    {
        Id: 385,
        ParentId: 374,
        MenuName: "History",
        DisplayName: "History",
        DisplayNameBangla: "ইতিহাস",
        MenuUrl: "/history",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 13,
    },
    {
        Id: 386,
        ParentId: 374,
        MenuName: "News And Events",
        DisplayName: "News And Events",
        DisplayNameBangla: "নিউস এন্ড ইভেন্টস ",
        MenuUrl: "/news-and-events",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 14,
    },
    {
        Id: 387,
        ParentId: 374,
        MenuName: "Why Study ",
        DisplayName: "Why Study ",
        DisplayNameBangla: "হোয়াই স্টাডি ",
        MenuUrl: "/why-study",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 15,
    },
    {
        Id: 388,
        ParentId: 374,
        MenuName: "Vision",
        DisplayName: "Vision",
        DisplayNameBangla: "ভিশন",
        MenuUrl: "/vision",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 16,
    },
    {
        Id: 389,
        ParentId: 374,
        MenuName: "Mission",
        DisplayName: "Mission",
        DisplayNameBangla: "মিশন",
        MenuUrl: "/mission",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 17,
    },
    {
        Id: 390,
        ParentId: 374,
        MenuName: "Achievements",
        DisplayName: "Achievements",
        DisplayNameBangla: "অর্জন  | এচিভমেন্টস ",
        MenuUrl: "/achievements",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 1,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 18,
    },
    {
        Id: 391,
        ParentId: 374,
        MenuName: "Oath",
        DisplayName: "Oath",
        DisplayNameBangla: "শপথ",
        MenuUrl: "/oath",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 19,
    },
    {
        Id: 392,
        ParentId: 374,
        MenuName: "Infustructure",
        DisplayName: "Infustructure",
        DisplayNameBangla: "অবকাঠামো",
        MenuUrl: "/infustructure",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "About Us ",
        DisplayNameParentBangla: "আমাদের সম্পর্কে",
        MenuOrder: null,
        MenuCode: 20,
    },
    {
        Id: 393,
        ParentId: 375,
        MenuName: "Academic Rules",
        DisplayName: "Academic Rules",
        DisplayNameBangla: "একাডেমিক নিয়ম",
        MenuUrl: "/academic-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 21,
    },
    {
        Id: 394,
        ParentId: 375,
        MenuName: "School Class Routine",
        DisplayName: "School Class Routine",
        DisplayNameBangla: "ক্লাস রুটিন | স্কুল ক্লাস রুটিন",
        MenuUrl: "/class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 22,
    },
    {
        Id: 395,
        ParentId: 375,
        MenuName: "College Class Routine",
        DisplayName: "College Class Routine",
        DisplayNameBangla: "কলেজের ক্লাস রুটিন",
        MenuUrl: "/college-class-routine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 23,
    },
    {
        Id: 396,
        ParentId: 375,
        MenuName: "Lesson Plan",
        DisplayName: "Lesson Plan",
        DisplayNameBangla: "পাঠ পরিকল্পনা",
        MenuUrl: "/lesson-plan",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 24,
    },
    {
        Id: 397,
        ParentId: 375,
        MenuName: "Academic Calendar ",
        DisplayName: "Academic Calendar ",
        DisplayNameBangla: "শিক্ষা বর্ষপঞ্জি ",
        MenuUrl: "/academic-calendar ",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 25,
    },
    {
        Id: 398,
        ParentId: 375,
        MenuName: "Holiday Calendar",
        DisplayName: "Holiday Calendar",
        DisplayNameBangla: "ছুটির ক্যালেন্ডার",
        MenuUrl: "/holiday-calender",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 26,
    },
    {
        Id: 399,
        ParentId: 375,
        MenuName: "Notice",
        DisplayName: "Notice",
        DisplayNameBangla: "নোটিশ ",
        MenuUrl: "/notice",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 27,
    },
    {
        Id: 400,
        ParentId: 375,
        MenuName: "Course And Program",
        DisplayName: "Course And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/course-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 28,
    },
    {
        Id: 401,
        ParentId: 375,
        MenuName: "Syllabus And Booklist",
        DisplayName: "Syllabus And Booklist",
        DisplayNameBangla: "সিলেবাস এবং বুকলিস্ট",
        MenuUrl: "/syllabus-and-booklist",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 29,
    },
    {
        Id: 402,
        ParentId: 375,
        MenuName: "Prospectus",
        DisplayName: "Prospectus",
        DisplayNameBangla: "প্রসপেক্টাস",
        MenuUrl: "/prospectus",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 30,
    },
    {
        Id: 403,
        ParentId: 375,
        MenuName: "Magazine",
        DisplayName: "Magazine",
        DisplayNameBangla: "ম্যাগাজিন",
        MenuUrl: "/magazine",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 31,
    },
    {
        Id: 404,
        ParentId: 375,
        MenuName: "Rules and Regulations",
        DisplayName: "Rules and Regulations",
        DisplayNameBangla: "নিয়ম এবং প্রবিধান",
        MenuUrl: "/rules-and-regulations",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 32,
    },
    {
        Id: 405,
        ParentId: 375,
        MenuName: "Uniform | School Uniform Info",
        DisplayName: "Uniform | School Uniform Info",
        DisplayNameBangla: "ইউনিফর্ম | স্কুল ইউনিফর্ম তথ্য",
        MenuUrl: "/uniform",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 33,
    },
    {
        Id: 406,
        ParentId: 375,
        MenuName: "Suggestion | Suggestions To Parents",
        DisplayName: "Suggestion | Suggestions To Parents",
        DisplayNameBangla: "পরামর্শ | অভিভাবকদের পরামর্শ",
        MenuUrl: "/suggestion",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 34,
    },
    {
        Id: 407,
        ParentId: 375,
        MenuName: "Other Information ",
        DisplayName: "Other Information ",
        DisplayNameBangla: "অন্যান্য",
        MenuUrl: "/online-information ",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 35,
    },
    {
        Id: 408,
        ParentId: 375,
        MenuName: "Coordinator",
        DisplayName: "Coordinator",
        DisplayNameBangla: "কোঅর্ডিনেটর ",
        MenuUrl: "/coordinator",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 36,
    },
    {
        Id: 409,
        ParentId: 375,
        MenuName: "Our Curriculum",
        DisplayName: "Our Curriculum",
        DisplayNameBangla: "আমাদের পাঠ্যক্রম",
        MenuUrl: "/our-curriculum",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 2,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 37,
    },
    {
        Id: 410,
        ParentId: 375,
        MenuName: "Extra-Co-Curricular",
        DisplayName: "Extra-Co-Curricular",
        DisplayNameBangla: "এক্সট্রা-কো-কারিকুলার",
        MenuUrl: "/extra-co-curricular",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 38,
    },
    {
        Id: 411,
        ParentId: 375,
        MenuName: "Class Time Schedule",
        DisplayName: "Class Time Schedule",
        DisplayNameBangla: "ক্লাসের সময়সূচী",
        MenuUrl: "/class-time-schedule",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 39,
    },
    {
        Id: 412,
        ParentId: 375,
        MenuName: "Club Activity",
        DisplayName: "Club Activity",
        DisplayNameBangla: "ক্লাব কার্যকলাপ",
        MenuUrl: "/club-activity",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Academic ",
        DisplayNameParentBangla: "একাডেমিক / পাঠ্যক্রম",
        MenuOrder: null,
        MenuCode: 40,
    },
    {
        Id: 413,
        ParentId: 376,
        MenuName: "Admission Circular ",
        DisplayName: "Admission Circular ",
        DisplayNameBangla: "ভর্তি বিজ্ঞপ্তি ",
        MenuUrl: "/admission-circular",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 41,
    },
    {
        Id: 414,
        ParentId: 376,
        MenuName: "Admission Form",
        DisplayName: "Admission Form",
        DisplayNameBangla: "ভর্তি ফরম",
        MenuUrl: "/admission-form",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 42,
    },
    {
        Id: 415,
        ParentId: 376,
        MenuName: "Selected Candidates",
        DisplayName: "Selected Candidates",
        DisplayNameBangla: "নির্বাচিত প্রার্থীরা",
        MenuUrl: "/selected-candidates",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 43,
    },
    {
        Id: 416,
        ParentId: 376,
        MenuName: "Waiting list",
        DisplayName: "Waiting list",
        DisplayNameBangla: "ওয়েটিং লিস্ট ",
        MenuUrl: "/waiting-list",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 44,
    },
    {
        Id: 417,
        ParentId: 376,
        MenuName: "Admission Result",
        DisplayName: "Admission Result",
        DisplayNameBangla: "ভর্তির ফলাফল",
        MenuUrl: "/admission-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 45,
    },
    {
        Id: 418,
        ParentId: 376,
        MenuName: "Exam Rules",
        DisplayName: "Exam Rules",
        DisplayNameBangla: "পরীক্ষার নিয়ম",
        MenuUrl: "/exam-rules",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 46,
    },
    {
        Id: 419,
        ParentId: 376,
        MenuName: "Courses And Program",
        DisplayName: "Courses And Program",
        DisplayNameBangla: "কোর্স এবং প্রোগ্রাম",
        MenuUrl: "/courses-and-program",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 47,
    },
    {
        Id: 420,
        ParentId: 376,
        MenuName: "FAQ",
        DisplayName: "FAQ",
        DisplayNameBangla: "এফ এ কিউ ",
        MenuUrl: "/faq",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 48,
    },
    {
        Id: 421,
        ParentId: 376,
        MenuName: "Admission Procedure",
        DisplayName: "Admission Procedure",
        DisplayNameBangla: "ভর্তির পদ্ধতি",
        MenuUrl: "/admission-procedure",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 49,
    },
    {
        Id: 422,
        ParentId: 376,
        MenuName: "Payment Process",
        DisplayName: "Payment Process",
        DisplayNameBangla: "পেমেন্ট প্রক্রিয়া",
        MenuUrl: "/payment-process",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 50,
    },
    {
        Id: 423,
        ParentId: 376,
        MenuName: "Download Admit Card",
        DisplayName: "Download Admit Card",
        DisplayNameBangla: "অ্যাডমিট কার্ড ডাউনলোড",
        MenuUrl: "/download-admit-card",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 51,
    },
    {
        Id: 424,
        ParentId: 376,
        MenuName: "Admission Instruction",
        DisplayName: "Admission Instruction",
        DisplayNameBangla: "ভর্তির নির্দেশনা",
        MenuUrl: "/admission-instruction",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Admission ",
        DisplayNameParentBangla: "ভর্তি",
        MenuOrder: null,
        MenuCode: 52,
    },
    {
        Id: 425,
        ParentId: 377,
        MenuName: "Governing Body",
        DisplayName: "Governing Body",
        DisplayNameBangla: "পরিচালনা পর্ষদ",
        MenuUrl: "/administration/governing-body",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 53,
    },
    {
        Id: 426,
        ParentId: 377,
        MenuName: "Message Of Chief Patron",
        DisplayName: "Message Of Chief Patron",
        DisplayNameBangla: "প্রধান পৃষ্ঠপোষক বার্তা",
        MenuUrl: "/administration/message-of-chief-patron",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 54,
    },
    {
        Id: 427,
        ParentId: 377,
        MenuName: "Message Of Chairman ",
        DisplayName: "Message Of Chairman ",
        DisplayNameBangla: "চেয়ারম্যানের বার্তা",
        MenuUrl: "/administration/message-of-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 55,
    },
    {
        Id: 428,
        ParentId: 377,
        MenuName: "Message of Vice Chairman",
        DisplayName: "Message of Vice Chairman",
        DisplayNameBangla: "ভাইস চেয়ারম্যানের বার্তা",
        MenuUrl: "/administration/message-of-vice-chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 56,
    },
    {
        Id: 429,
        ParentId: 377,
        MenuName: "Message of Principal",
        DisplayName: "Message of Principal",
        DisplayNameBangla: "অধ্যক্ষের বার্তা",
        MenuUrl: "/administration/message-of-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 57,
    },
    {
        Id: 430,
        ParentId: 377,
        MenuName: "Message Of Vice Principal",
        DisplayName: "Message Of Vice Principal",
        DisplayNameBangla: "ভাইস প্রিন্সিপালের বার্তা",
        MenuUrl: "/administration/message-of-vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 58,
    },
    {
        Id: 431,
        ParentId: 377,
        MenuName: "Student Advisor",
        DisplayName: "Student Advisor",
        DisplayNameBangla: "ছাত্র-ছাত্রীদের উপদেষ্টা",
        MenuUrl: "/student-advisor",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 59,
    },
    {
        Id: 432,
        ParentId: 377,
        MenuName: "Academic Organogram",
        DisplayName: "Academic Organogram",
        DisplayNameBangla: "একাডেমিক অর্গানোগ্রাম",
        MenuUrl: "/academic-organogram",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 60,
    },
    {
        Id: 433,
        ParentId: 377,
        MenuName: "Ex-Chairman | Chairman",
        DisplayName: "Ex-Chairman | Chairman",
        DisplayNameBangla: "প্রাক্তন চেয়ারম্যান | চেয়ারম্যান",
        MenuUrl: "/chairman",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 61,
    },
    {
        Id: 434,
        ParentId: 377,
        MenuName: "Ex-Principals | Principal",
        DisplayName: "Ex-Principals | Principal",
        DisplayNameBangla: "প্রাক্তন অধ্যক্ষ | অধ্যক্ষ",
        MenuUrl: " /principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 62,
    },
    {
        Id: 435,
        ParentId: 377,
        MenuName: "Ex-Vice Principals | Vice Principal",
        DisplayName: "Ex-Vice Principals | Vice Principal",
        DisplayNameBangla: "প্রাক্তন ভাইস প্রিন্সিপাল | ভাইস প্রিন্সিপাল",
        MenuUrl: "/vice-principal",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 63,
    },
    {
        Id: 436,
        ParentId: 377,
        MenuName: "Ex-Teacher",
        DisplayName: "Ex-Teacher",
        DisplayNameBangla: "প্রাক্তন শিক্ষক",
        MenuUrl: "/ex-teacher",
        IsLeaf: true,
        FileType: 4,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 64,
    },
    {
        Id: 437,
        ParentId: 377,
        MenuName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayName:
            "Teacher Information | Teacher's List (School) | Teacher Information boys Section ",
        DisplayNameBangla: "শিক্ষকমন্ডলী (স্কুল শাখা))",
        MenuUrl: "/administration/teacher-information",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 65,
    },
    {
        Id: 438,
        ParentId: 377,
        MenuName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayName:
            "Teacher's List (College) | Teacher Information grils Section",
        DisplayNameBangla: "শিক্ষকমন্ডলী (কলেজ শাখা)",
        MenuUrl: "/teachers-list-college",
        IsLeaf: true,
        FileType: 5,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 66,
    },
    {
        Id: 439,
        ParentId: 377,
        MenuName: "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayName:
            "Staff Information | Officers & Staffs List | Non Teaching",
        DisplayNameBangla: "কর্মচারীর তালিকা",
        MenuUrl: "/staff-information",
        IsLeaf: true,
        FileType: 6,
        LayoutType: 3,
        DisplayNameParent: "Administration  | Associates",
        DisplayNameParentBangla: "প্রশাসন | সহযোগী",
        MenuOrder: null,
        MenuCode: 67,
    },
    {
        Id: 440,
        ParentId: 378,
        MenuName: "Institution Result",
        DisplayName: "Institution Result",
        DisplayNameBangla: "প্রতিষ্ঠানের ফলাফল",
        MenuUrl: "/institution-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 68,
    },
    {
        Id: 441,
        ParentId: 378,
        MenuName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayName: "Board Result | HSC Results | SSC Results | JSC Results",
        DisplayNameBangla: "বোর্ডের ফলাফল | এইচএসসি ফলাফল | এসএসসি ফলাফল",
        MenuUrl: "/board-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 69,
    },
    {
        Id: 442,
        ParentId: 378,
        MenuName: "Scholarship Result",
        DisplayName: "Scholarship Result",
        DisplayNameBangla: "বৃত্তি ফলাফল",
        MenuUrl: "/scholarship-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 70,
    },
    {
        Id: 443,
        ParentId: 378,
        MenuName: "Admission Test Result",
        DisplayName: "Admission Test Result",
        DisplayNameBangla: "ভর্তি পরীক্ষার ফলাফল",
        MenuUrl: "/admission-test-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 71,
    },
    {
        Id: 444,
        ParentId: 378,
        MenuName: "Recruitment",
        DisplayName: "Recruitment",
        DisplayNameBangla: "নিয়োগ | রিক্রুটমেন্ট",
        MenuUrl: "/recruitment",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 72,
    },
    {
        Id: 445,
        ParentId: 378,
        MenuName: "Recruitment Result",
        DisplayName: "Recruitment Result",
        DisplayNameBangla: "নিয়োগের ফলাফল | রিক্রুটমেন্ট ফলাফল ",
        MenuUrl: "/recruitment-result",
        IsLeaf: true,
        FileType: 3,
        LayoutType: 1,
        DisplayNameParent: "Result",
        DisplayNameParentBangla: "রেজাল্ট ",
        MenuOrder: null,
        MenuCode: 73,
    },
    {
        Id: 446,
        ParentId: 379,
        MenuName: "Cultural Club",
        DisplayName: "Cultural Club",
        DisplayNameBangla: "সাংস্কৃতিক ক্লাব",
        MenuUrl: "/cultural-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 74,
    },
    {
        Id: 447,
        ParentId: 379,
        MenuName: "Quiz club",
        DisplayName: "Quiz club",
        DisplayNameBangla: "কুইজ ক্লাব",
        MenuUrl: "/quiz-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 75,
    },
    {
        Id: 448,
        ParentId: 379,
        MenuName: "IT club",
        DisplayName: "IT club",
        DisplayNameBangla: "আইটি ক্লাব",
        MenuUrl: "/it-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 76,
    },
    {
        Id: 449,
        ParentId: 379,
        MenuName: "Business club",
        DisplayName: "Business club",
        DisplayNameBangla: "ব্যবসায়িক ক্লাব",
        MenuUrl: "/business-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 77,
    },
    {
        Id: 450,
        ParentId: 379,
        MenuName: "Blood Donation club",
        DisplayName: "Blood Donation club",
        DisplayNameBangla: "রক্তদান ক্লাব",
        MenuUrl: "/blood-donation-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 78,
    },
    {
        Id: 451,
        ParentId: 379,
        MenuName: "Quran Learning Club",
        DisplayName: "Quran Learning Club",
        DisplayNameBangla: "কোরআন লার্নিং ক্লাব",
        MenuUrl: "/quran-learning-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 79,
    },
    {
        Id: 452,
        ParentId: 379,
        MenuName: "General Knowledge Club",
        DisplayName: "General Knowledge Club",
        DisplayNameBangla: "সাধারণ জ্ঞান ক্লাব",
        MenuUrl: "/general-knowledge-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 80,
    },
    {
        Id: 453,
        ParentId: 379,
        MenuName: "Language Club",
        DisplayName: "Language Club",
        DisplayNameBangla: "ভাষা ক্লাব",
        MenuUrl: "/language-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 81,
    },
    {
        Id: 454,
        ParentId: 379,
        MenuName: "Sports & Karate Club",
        DisplayName: "Sports & Karate Club",
        DisplayNameBangla: "ক্রীড়া ও কারাতে ক্লাব",
        MenuUrl: "/sports-&-karate-club",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 82,
    },
    {
        Id: 455,
        ParentId: 379,
        MenuName: "Science Club:",
        DisplayName: "Science Club:",
        DisplayNameBangla: "বিজ্ঞান ক্লাব:",
        MenuUrl: "",
        IsLeaf: false,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 83,
    },
    {
        Id: 456,
        ParentId: 379,
        MenuName: "Physics",
        DisplayName: "Physics",
        DisplayNameBangla: "পদার্থ-বিজ্ঞান",
        MenuUrl: "/physics",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 84,
    },
    {
        Id: 457,
        ParentId: 379,
        MenuName: "Chemistry",
        DisplayName: "Chemistry",
        DisplayNameBangla: "রসায়ন",
        MenuUrl: "/chemistry",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 85,
    },
    {
        Id: 458,
        ParentId: 379,
        MenuName: "BNCC Society",
        DisplayName: "BNCC Society",
        DisplayNameBangla: "বিএনসিসি সোসাইটি",
        MenuUrl: "/bncc-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 86,
    },
    {
        Id: 459,
        ParentId: 379,
        MenuName: "Rover Scout Society",
        DisplayName: "Rover Scout Society",
        DisplayNameBangla: "রোভার স্কাউট সোসাইটি",
        MenuUrl: "/rover scout society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 87,
    },
    {
        Id: 460,
        ParentId: 379,
        MenuName: "Football Society",
        DisplayName: "Football Society",
        DisplayNameBangla: "ফুটবল সোসাইটি",
        MenuUrl: "/football-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 88,
    },
    {
        Id: 461,
        ParentId: 379,
        MenuName: "Cricket Society",
        DisplayName: "Cricket Society",
        DisplayNameBangla: "ক্রিকেট সোসাইটি",
        MenuUrl: "/cricket-society",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Club & Scociety / Activites ",
        DisplayNameParentBangla: "ক্লাব",
        MenuOrder: null,
        MenuCode: 89,
    },
    {
        Id: 462,
        ParentId: 381,
        MenuName: "Photo Gallery",
        DisplayName: "Photo Gallery",
        DisplayNameBangla: "ফটোস",
        MenuUrl: "/photo-gallery",
        IsLeaf: true,
        FileType: 1,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 90,
    },
    {
        Id: 463,
        ParentId: 381,
        MenuName: "Video Gallery",
        DisplayName: "Video Gallery",
        DisplayNameBangla: "ভিডিওস",
        MenuUrl: "/video-gallery",
        IsLeaf: true,
        FileType: 2,
        LayoutType: 3,
        DisplayNameParent: "Gallery ",
        DisplayNameParentBangla: "গ্যালারি",
        MenuOrder: null,
        MenuCode: 91,
    },
    {
        Id: 464,
        ParentId: 383,
        MenuName: "Student's Login",
        DisplayName: "Student's Login",
        DisplayNameBangla: "স্টুডেন্ট'স লগইন ",
        MenuUrl: "/student's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 92,
    },
    {
        Id: 465,
        ParentId: 383,
        MenuName: "Teacher's Login",
        DisplayName: "Teacher's Login",
        DisplayNameBangla: "টিচার'স লগইন ",
        MenuUrl: "/teacher's-login",
        IsLeaf: true,
        FileType: 0,
        LayoutType: 2,
        DisplayNameParent: "Login ",
        DisplayNameParentBangla: "লগ-ইন",
        MenuOrder: null,
        MenuCode: 93,
    },
];
